import type * as Types from 'app/types/graphql';

export type CampaignWithProductSelectFragment = Pick<
  Types.Campaign,
  | 'id'
  | 'name'
  | 'type'
  | 'status'
  | 'priority'
  | 'storeDomain'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
  | 'deletedAt'
  | 'completedAt'
> & {
  product?: Types.Maybe<
    Pick<
      Types.CampaignProduct,
      'id' | 'baseID' | 'title' | 'image' | 'handle' | 'createdAt' | 'updatedAt'
    >
  >;
  variants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Variant,
          | 'id'
          | 'isOrigin'
          | 'isWinner'
          | 'trafficRate'
          | 'themePageID'
          | 'templateType'
          | 'templateSuffix'
          | 'createdAt'
          | 'deletedAt'
          | 'updatedAt'
          | 'winnerTemplateSuffix'
        > & {
          template?: Types.Maybe<
            Pick<
              Types.VariantTemplate,
              | 'createdAt'
              | 'deletedAt'
              | 'id'
              | 'redirectURL'
              | 'themeID'
              | 'updatedAt'
              | 'thumbnailURL'
              | 'title'
            >
          >;
          price?: Types.Maybe<
            Pick<
              Types.VariantPrice,
              | 'id'
              | 'baseID'
              | 'handle'
              | 'status'
              | 'title'
              | 'redirectURL'
              | 'sourceProductBaseID'
            >
          >;
          productVariants?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.VariantProductVariant,
                  'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                >
              >
            >
          >;
          url?: Types.Maybe<
            Pick<
              Types.VariantUrl,
              'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
            >
          >;
        }
      >
    >
  >;
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.SplitTestingCampaignVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export type CampaignProductSelectFragment = Pick<
  Types.CampaignProduct,
  'id' | 'baseID' | 'title' | 'image' | 'handle' | 'createdAt' | 'updatedAt'
>;

export const CampaignProductSelectFragmentDoc = `
    fragment CampaignProductSelect on CampaignProduct {
  id
  baseID
  title
  image
  handle
  createdAt
  updatedAt
}
    `;
export const CampaignWithProductSelectFragmentDoc = `
    fragment CampaignWithProductSelect on Campaign {
  ...CampaignSelect
  product {
    ...CampaignProductSelect
  }
  variants {
    ...VariantWithTemplateSelect
  }
}
    `;
